<template>
  <div class="invoice-line">
    <div class="invoice-line-cell">
      <span>{{lineData.ttyp}}</span>&nbsp;&nbsp;&nbsp;<span class="link" @click="vGoToInvoiceDetail">{{lineData.tnfac}}</span>
    </div>
    <div class="invoice-line-cell">
      <span>{{this.$dateformat(lineData.tdate_fact)}}</span>
    </div>
    <div class="invoice-line-cell">
      <span>{{this.$dateformat(lineData.tdate_ech)}}</span>
    </div>
    <div class="invoice-line-cell">
      <span>{{lineData.tlib_modp}}</span>
    </div>
    <div class="invoice-line-cell">
      <span>{{lineData.tmontht}} {{lineData.tcdev}}</span>
    </div>
    <div class="invoice-line-cell">
      <span>{{lineData.tmontttc}} {{lineData.tcdev}}</span>
    </div>
    <div class="invoice-line-cell">
      <span class="invoice-pdf" @click="vDownloadInvoice">
        <i class="material-icons">get_app</i>
      </span>
    </div>
  </div>
</template>

<script>

import invoiceService from "@/modules/facture/services/invoiceService";

export default {
  props: ["dataline", "index"],
  name: "invoiceLine",
  data() {
    return {
      lineData: {
        ttyp: this.$props.dataline.TTYP, //Type : A pour Avoir / F pour Facture
        tnfac: this.$props.dataline.TNFAC, //N° facture
        tdate_fact: this.$props.dataline.TDATE_FACT, // Date facture
        tdate_ech: this.$props.dataline.TDATE_ECH, //Date échéance
        tmodp: this.$props.dataline.TMODP, //Mode de paiement
        tlib_modp: this.$props.dataline.TLIB_MODP, //Libellé de mode de paiement
        tmontht: this.$props.dataline.TMONTHT, //Montant HT
        tmontttc: this.$props.dataline.TMONTTTC, //Montant TTC
        tcdev: this.$store.getters['application/get_application_customer'].TCDEV
      }
    };
  },
  methods: {
    vGoToInvoiceDetail() {
      this.$store.dispatch("facture/SELECT", {
        key: "tnfac_selected",
        value: this.lineData.tnfac
      });
      this.$router.push({
        name: "invoicedetails",
        params: {
          invoice_id: this.lineData.tnfac,
          invoice_date: this.lineData.tdate_fact,
          invoice_amount: this.lineData.tmontttc
        }
      });
    },
    vDownloadInvoice() {
      invoiceService.getDownloadInvoice(this.lineData.tnfac)
      .then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.lineData.tnfac+'.pdf');
        document.body.appendChild(link);
        link.click();
      })
      .catch(err => {
        console.error(err);
      });
    },
  },
  computed: {
    currency: function() {
      let currencies = { EUR: "€" }; //TODO Placer les autres devises possibles

      if (typeof currencies[this.lineData.tcdev] != "undefined") {
        return currencies[this.lineData.tcdev];
      } else {
        return "€";
      }
    }
  }
};
</script>

<style scoped>
.invoice-line {
  display: flex;
  border: solid 1px #e9e9e9;
  margin-top: 10px;
  transition: all 0.3s;
  align-items: center;
}
.invoice-line-cell {
  display: flex;
  width: calc(100% / 7);
  justify-content: center;
  padding: 25px 0px;
}
.invoice-line-cell span {
  color: #585858;
  font-size: var(--fz-md);
  transition: all 0.3s;
}
.invoice-line:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}
.invoice-line:hover .invoice-line-cell span {
  color: #8b8b8b;
}
.invoice-pdf {
  padding: 3px;
  border-style: solid;
  border-width: 1px;
}
.invoice-pdf:hover {
  background: #ddd;
}
.link {
  text-decoration: underline;
}
</style>